module.exports = __webpack_public_path__ + "/bundle/asset/U1_02-7e6546348b3636b58842b50764634e82.gif";